export default __webpack_public_path__ + "static/media/monogram.53344437.svg";